// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const TitleCase_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M19.5 5.25v3a.75.75 0 0 1-1.5 0V6h-5.25v12H15a.75.75 0 0 1 0 1.5H9A.75.75 0 0 1 9 18h2.25V6H6v2.25a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75h13.5a.75.75 0 0 1 .75.75Z',
  viewBox: '0 0 24 24',
  glyph: 'TitleCase_Stroke2_Corner0_Rounded',
})
